<mat-divider class="tab-header"></mat-divider>
<div class="tab-content-container">
    <div>
        <div class="tapestry-body body--sm text-spacing">
            {{
                'seller-tools-panel.workshop-accounts.tab-description'
                    | translate
            }}
        </div>
        <div
            class="tapestry-body body--sm text-spacing"
            [innerHTML]="
                'seller-tools-panel.workshop-accounts.tab-sub-description'
                    | translate
            "
        ></div>
        @if (!showWorkshopCreateField) {
            <tapestry-button
                class="action-btn"
                [text]="
                    'seller-tools-panel.workshop-accounts.tab.create-button'
                        | translate
                "
                icon="add"
                [size]="ButtonSize.Small"
                (buttonClicked)="showAddWorkshopAccount()"
                [disabled]="saving"
                trackingName="createWorkshopAccountBtn"
            ></tapestry-button>
        }
        @if (showWorkshopCreateField) {
            <form class="workshop-form" [formGroup]="workshopForm">
                <tapestry-text
                    [label]="
                        'seller-tools-panel.workshop-accounts.tab.workshop-title'
                            | translate
                    "
                    [control]="workshopForm.controls.workshopName"
                    [required]="true"
                    formControlName="workshopName"
                    trackingName="workshopAccountName"
                ></tapestry-text>
                @if (
                    workshopForm.controls.workshopName.invalid &&
                    (workshopForm.controls.workshopName.dirty ||
                        workshopForm.controls.workshopName.touched)
                ) {
                    <div class="form-error-body tapestry-body body--sm">
                        @if (
                            workshopForm.controls.workshopName.errors?.required
                        ) {
                            {{
                                'platform.create-workshop-account.controls.workshop-name.validation.required'
                                    | translate
                            }}
                        }
                        @if (
                            workshopForm.controls.workshopName.errors
                                ?.duplicateProspectName
                        ) {
                            {{
                                'platform.create-workshop-account.controls.workshop-name.validation.duplicate-workshop-name'
                                    | translate
                            }}
                        }
                    </div>
                }
                <div class="workshop-button-section">
                    <tapestry-button
                        [text]="'text.common-terms.cancel' | translate"
                        [color]="ButtonColor.Secondary"
                        [size]="ButtonSize.Small"
                        (buttonClicked)="cancel()"
                    ></tapestry-button>
                    <tapestry-button
                        [text]="
                            'seller-tools-panel.workshop-accounts.tab.create-button'
                                | translate
                        "
                        [size]="ButtonSize.Small"
                        (buttonClicked)="saveChanges()"
                        trackingName="createWorkshopAccountBtn"
                    ></tapestry-button>
                </div>
            </form>
        }
    </div>
    <ag-grid-angular
        #workshopAccountsGrid
        class="ag-theme-tapestry-grid seller-tools-grid"
        [columnDefs]="columnDefs"
        rowSelection="multiple"
        [suppressRowClickSelection]="true"
        [rowData]="workshopAccountData$ | async"
        (gridReady)="gridReadyHandler($event)"
        trackingName="workshopAccountsGrid"
    ></ag-grid-angular>
</div>
